import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=79442e6d&scoped=true"
import script from "./historyRecord.vue?vue&type=script&lang=js"
export * from "./historyRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79442e6d",
  null
  
)

export default component.exports